import ApexChart, { Props as ApexChartProps } from "react-apexcharts";

type Props = {
  categories: string[];
  data: number[];
  seriesName?: string;
  height: number;
};

const LineChart = ({ categories, data, seriesName, height }: Props) => {
  const series: ApexChartProps["series"] = [
    { name: seriesName, data, type: "line" },
  ];

  const options: ApexChartProps["options"] = {
    chart: {
      animations: { enabled: false },
      type: "line",
      zoom: {
        enabled: false,
      },
      foreColor: "#fff",
      toolbar: {
        show: false,
      },
    },
    colors: ["#22CAB7"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    markers: {
      size: 4,
      colors: ["#0E534B"],
      hover: { size: 6 },
    },
    tooltip: {
      x: { show: false },
    },
    grid: {
      row: {
        colors: ["transparent"],
        opacity: 0.3,
      },
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: false } },
    },
    xaxis: {
      categories,
    },
  };

  return (
    <div className="h-[240px] bg-gradient-to-b from-[#0E534BDD] to-[#0E534B55]">
      <ApexChart options={options} series={series} height={height} />
    </div>
  );
};

export default LineChart;
